import { debounce } from "lodash";
import { useMemo, useState } from "react";

import { useGetPositions } from "~/entity/Positions";

/**
 * Опции должностей для селектов с ленивым поиском
 * (аналог useGetAllDirectionsForSelectLazy для справочника должностей).
 */
export const usePositionsSelectOptions = (count = 50) => {
  const [searchText, setSearchText] = useState("");

  const { positions, isLoading } = useGetPositions({
    searchText: searchText || undefined,
    count,
  });

  const searchOptions = useMemo(
    () => debounce((text: string) => setSearchText(text), 300),
    [],
  );

  const options = useMemo(
    () =>
      (positions ?? [])
        .filter(
          ({ instanceId }) => instanceId !== undefined && instanceId !== null,
        )
        .map(({ instanceId, code, name }) => ({
          value: instanceId,
          // По дизайну подпись опции — `${code}. ${name}`.
          label: code ? `${code}. ${name}` : name,
        })),
    [positions],
  );

  return { options, isLoading, searchOptions };
};
